import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Select, Switch } from 'antd'
import { Col } from 'styled-bootstrap-grid'
import styled from 'styled-components/macro'
import { SelectValue } from 'antd/lib/select'
import { selectedFlow, getFlowValidationResult, isValidating } from '../../../features/flow/selectors'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNavigationWrapper, WizardNav, NavProps } from '../../../components/Wizard/WizardNav'
import { CenteredRow, Label } from '../../../components/Page/Layout'
import { Row } from '../../../components/Grid'
import { FlowActions } from '../../../features/flow/actions'
import { fetchChatPatterns } from '../../../api/chatPattern'
import { fetchAllPaymentTemplates } from '../../../api/paymentTemplate'
import { fetchActionPatterns } from '../../../api/actionPattern'
import { fetchProfilePatterns } from '../../../api/profilePattern'

const { Option } = Select

const StyledSelect = styled(Select)`
  width: 100%;
`

type BaseResp = {
  id: string
  name: string
}

type AddFlowBaseProps = {
  close?: () => void
} & NavProps

export const AddFlowBase: React.FC<AddFlowBaseProps> = ({ close, ...rest }: AddFlowBaseProps) => {
  const dispatch = useDispatch()
  const flow = useSelector(selectedFlow)
  const status = useSelector(getFlowValidationResult)
  const loading = useSelector(isValidating)

  const [chatPatterns, setChatPatterns] = useState<BaseResp[]>([])
  const [paymentTemplates, setPaymentTemplates] = useState<BaseResp[]>([])
  const [actionPatterns, setActionPatterns] = useState<BaseResp[]>([])
  // const [profilePatterns, setProfilePatterns] = useState<ProfilePatternResp[]>([])

  useEffect(() => {
    const loadData = async () => {
      const resp = await fetchChatPatterns()
      if (resp && resp.data.length > 0) {
        setChatPatterns(resp.data)
      }

      const pt = await fetchAllPaymentTemplates()
      if (pt && pt.data) {
        setPaymentTemplates(pt.data)
      }

      const ap = await fetchActionPatterns()
      if (ap && ap.data) {
        setActionPatterns(ap.data)
      }
    }

    loadData()
  }, [])

  const changeHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const flowToValidate = {
      ...flow,
      name: e.target.value
    }
    dispatch(FlowActions.updateNewFlow(flowToValidate))
    if (flowToValidate.name && flowToValidate.name.length > 2) {
      dispatch(FlowActions.startFlowValidation(flowToValidate))
    }
  }

  const changeSelect = (field: string, value: SelectValue | string) => {
    if (flow && flow.name) {
      const flowToValidate = { ...flow, [field]: value }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
    }
  }

  function changeConfig(data: any) {
    if (flow && flow.name) {
      const oldValue = flow.config
      const flowToValidate = { ...flow, config: { ...oldValue, ...data } }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
    }
  }

  if (!flow) return <LoadingOverlay loading>&nbsp;</LoadingOverlay>

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Informazioni Base</CenteredRow>
        <Row>
          <Col md={6} mdOffset={2} xs={6} xsOffset={0}>
            <div>
              <Label>nome Flow</Label>
              <Input placeholder="nome" onChange={changeHandler} value={flow?.name} />
              <span className="error-input">{status && status.message}</span>
            </div>
          </Col>
          <Col md={2} xs={4} xsOffset={0}>
            <div>
              <Label>Adult</Label>
              <Switch
                checkedChildren={<span>Si</span>}
                unCheckedChildren={<span>No</span>}
                defaultChecked
                checked={flow.config?.onlyAdult || false}
                onChange={(c: boolean) => {
                  changeConfig({
                    onlyAdult: c
                  })
                }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2} xs={12} xsOffset={0}>
            <Label>Chat Pattern</Label>
            <StyledSelect value={flow?.chatPatternId || ''} onChange={value => changeSelect('chatPatternId', value)}>
              {_.map(chatPatterns, (p: BaseResp) => (
                <Option key={p.id} value={p.id}>
                  {p.name}
                </Option>
              ))}
            </StyledSelect>
          </Col>

          <Col md={4} xs={12} xsOffset={0}>
            <Label>Payment Template</Label>
            <StyledSelect
              value={flow?.paymentTemplateId || ''}
              onChange={value => changeSelect('paymentTemplateId', value)}
            >
              {_.map(paymentTemplates, (p: BaseResp) => (
                <Option key={p.id} value={p.id}>
                  {p.name}
                </Option>
              ))}
            </StyledSelect>
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2} xs={12} xsOffset={0}>
            <Label>Action Pattern</Label>
            <StyledSelect value={flow?.patternId || ''} onChange={value => changeSelect('patternId', value)}>
              {_.map(actionPatterns, (p: BaseResp) => (
                <Option key={p.id} value={p.id}>
                  {p.name}
                </Option>
              ))}
            </StyledSelect>
          </Col>
          <Col md={4} xs={12} xsOffset={0}>
            <Label>Url di atterraggio</Label>
            <StyledSelect
              value={flow?.config?.baseurl || ''}
              onChange={value =>
                changeConfig({
                  baseurl: value
                })
              }
            >
              {_.map(['radar', 'match', 'chat'], (p: string) => (
                <Option key={p} value={p}>
                  {p}
                </Option>
              ))}
            </StyledSelect>
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} previousStep={close} nextDisabled={!status?.isValid || flow!.name.length < 3} />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
